
import { useCallback } from "react";
import { toggleMoviePlanToWatch } from "@/context/movie/movieActions";
import { toast } from "@/hooks/use-toast";
import { Movie } from "@/types/movie";

/**
 * Hook for toggling a movie's plan to watch status
 * FIXED: Removed AuthError handling to prevent page refresh issues
 */
export const usePlanToWatchToggle = (
  allMovies: any[],
  pendingActions: any[],
  addPendingAction: (action: any) => void,
  removePendingAction: (actionId: string) => void,
  updateMovieState: (tmdbId: number, props: any) => void
) => {
  return useCallback(async (tmdbId: number, currentSection?: string, movieData?: Movie) => {
    try {
      // First try to find in user's collection using tmdbId
      let movie = allMovies.find(m => m.tmdbId === tmdbId);
      
      // If not found and we have movieData (from search results), use that
      if (!movie && movieData) {
        console.log(`Movie not in collection, using TMDB data for ${movieData.title}`);
        movie = movieData;
      }
      
      if (!movie) {
        toast({
          title: "Error",
          description: "Movie not found",
          variant: "destructive"
        });
        return;
      }
      
      // Call toggleMoviePlanToWatch with individual parameters as expected
      await toggleMoviePlanToWatch(
        movie,
        currentSection,
        pendingActions,
        addPendingAction,
        removePendingAction,
        updateMovieState
      );
    } catch (error) {
      console.error("Error toggling watchlist status:", error);
      
      // FIXED: No more AuthError handling - just log and show generic error
      toast({
        title: "Error",
        description: "Failed to update watchlist status",
        variant: "destructive"
      });
    }
  }, [allMovies, pendingActions, addPendingAction, removePendingAction, updateMovieState]);
};
